import {Injectable, inject} from '@angular/core';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';

import {AssetIconName} from 'frontend/platform/asset_icon/asset_icon.types';

/**
 * Icon Registry
 *
 * A simple way to register icons using
 * the patterns already found in application
 * roots
 *
 * ```typescript
 * inject(IconRegistry).register(yourIconMap);
 * ```
 */
@Injectable({
  providedIn: 'root',
})
export class IconRegistry {
  private readonly sanitizer = inject(DomSanitizer);
  private readonly registry = inject(MatIconRegistry);

  constructor() {
    this.registry.setDefaultFontSetClass('material-symbols-outlined', 'mat-ligature-font');
    this.registry.addSvgIcon(
      'tapestry-logo',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/tapestry_logo.svg'),
    );
  }

  registerSVGs(icons: Record<string, string>) {
    for (const [iconName, icon] of Object.entries(icons)) {
      this.registry.addSvgIconLiteral(iconName, this.sanitizer.bypassSecurityTrustHtml(icon));
    }
  }

  registerAssetIconLibrary(iconNames: readonly AssetIconName[]) {
    for (const iconName of iconNames) {
      this.registry.addSvgIcon(
        iconName,
        this.sanitizer.bypassSecurityTrustResourceUrl(`assets/icons/asset/${iconName}.svg`),
      );
    }
  }
}
